const DOMAIN = "https://www.streammasterspw.com";

export function setCanonical(pathname?: string) {
  const path = pathname || window.location.pathname;
  const url = `${DOMAIN}${path}`;
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (link) {
    link.setAttribute("href", url);
  } else {
    link = document.createElement("link");
    link.rel = "canonical";
    link.href = url;
    document.head.appendChild(link);
  }
}
